import React, { useState, useContext, useEffect, useCallback } from "react";
import AuthContext from "../../context/AuthContext";
import Paginator from "../paginator/Paginator";
import EditClienteModal from "./EditClienteModal";
import CreateClienteModal from "./CreateClienteModal";
import DeleteClienteButton from "./DeleteClienteButton";
import {
  getClientesService,
  deleteClienteService,
  updateClienteService,
  createClienteService,
} from "../../utils/ClienteService";
import Birthday from "../birthday/Birthday";
import Loading from "../loading/Loading";
import DetallePopOver from "./DetalleTooltip";

const TablaClientes = () => {
  const { authTokens } = useContext(AuthContext);
  const [clientes, setClientes] = useState([]);
  const [displayClientes, setDisplayClientes] = useState([]);

  // States de la barra de busqueda.
  const [busqueda, setBusqueda] = useState("");
  const [busquedaResult, setBusquedaResult] = useState([]);

  // State Loading
  const [loading, setLoading] = useState(true);

  // Funciones encargadas de pedir info a la db.
  const getClientes = useCallback(async () => {
    const clientes = await getClientesService(authTokens);
    setClientes(clientes ?? []);
    setLoading(false);
  }, [authTokens]);

  const deleteCliente = useCallback(
    async (id) => {
      await deleteClienteService(id, authTokens);
      const aux = clientes.filter((cliente) => cliente.id !== id);
      setClientes(aux);
      setBusqueda("");
    },
    [authTokens, clientes]
  );

  const updateCliente = useCallback(async (id, cliente) => {
    updateClienteService(id, cliente, authTokens).then((response) => {
      const aux = clientes.map((cli) => (cli.id === id ? response : cli));
      setClientes(aux);
    });
  });

  

  useEffect(() => {
    getClientes();
  }, []);

  // Cada vez que 'busqueda' cambie, corremos search()
  useEffect(() => {
    search();
  }, [busqueda]);

  // Funcion que maneja el cambio en el campo de busqueda de clientes
  const handleSearchChange = (search) => {
    setBusqueda(search);
  };

  // Funcion que maneja la busqueda
  const search = () => {
    // Si se escribio algo en busqueda filtramos sobre todos los clientes
    let aux = clientes.filter((cliente) =>
      getFullName(cliente).includes(busqueda.toLocaleLowerCase())
    );
    setBusquedaResult(aux);
  };

  const getFullName = (cliente) => {
    return (
      cliente.nombre.toLowerCase() +
      " " +
      cliente.apellido.toLowerCase() +
      " " +
      cliente.apellido.toLowerCase() +
      " " +
      cliente.nombre.toLowerCase()
    );
  };

  return (
    <div>
      <div className="row">
        <div className="mt-4  d-flex justify-content-start">
          {" "}
          <h4>Clientes</h4>{" "}
        </div>
      </div>
      <div className="row">
        <div className="col-lg-2 py-4 col-sm-12 d-flex justify-content-start">
          <CreateClienteModal clientes={clientes} setClientes={setClientes} />
        </div>
        <div className="col-lg-10 col-sm-12">
          <div className="input-group input-group-sm my-4">
            <input
              type="text"
              className="form-control"
              placeholder="Buscar cliente por nombre o apellido."
              value={busqueda}
              onChange={(e) => handleSearchChange(e.target.value)}
            />
            <div className="input-group-append">
              <button
                className="btn btn-outline-dark btn-sm"
                onClick={() => setBusqueda("")}
                type="button"
              >
                {busqueda ? "Borrar" : "Buscar"}
              </button>
            </div>
          </div>
        </div>
      </div>

      {loading ? (
        <Loading />
      ) : (
        <>
          <div className="table-responsive">
            <table className="table table-sm table-hover table-dark">
              <caption>Listado de Clientes</caption>
              <thead>
                <tr>
                  <th className="col-lg-1">Nombre</th>
                  <th className="col-lg-1">Apellido</th>
                  <th className="col-lg-2">Domicilio</th>
                  <th className="col-lg-1">Telefono</th>
                  <th className="col-lg-2">Mail</th>
                  <th className="col-lg-1">Detalle</th>
                  <th className="col-lg-1">Cumpleaños</th>
                  <th className="col-lg-1">Largo</th>
                  <th className="col-lg-2">Accion</th>
                </tr>
              </thead>
              <tbody>
                {busqueda.length > 0
                  ? busquedaResult.map((cliente) => {
                      return (
                        <tr key={cliente.id} className="table-light ">
                          <td>{cliente.nombre}</td>
                          <td>{cliente.apellido}</td>
                          <td>{cliente.domicilio}</td>
                          <td>{cliente.telefono}</td>
                          <td>{cliente.mail}</td>
                          <td><DetallePopOver detalle={cliente.info} nombre={cliente.nombre} apellido={cliente.apellido} /></td>
                          <td>{cliente.cumpleaños}</td>
                          <td>{cliente.largo_pelo}</td>
                          <td>
                            <EditClienteModal
                              cliente={cliente}
                              updateCliente={updateCliente}
                              setBusqueda={setBusqueda}
                            />
                            <DeleteClienteButton
                              id={cliente.id}
                              deleteCliente={deleteCliente}
                              setClientes={setClientes}
                            />
                          </td>
                        </tr>
                      );
                    })
                  : displayClientes.map((cliente) => {
                      return (
                        <tr key={cliente.id} className="table-light ">
                          <td>{cliente.nombre}</td>
                          <td>{cliente.apellido}</td>
                          <td>{cliente.domicilio}</td>
                          <td>{cliente.telefono}</td>
                          <td>{cliente.mail}</td>
                          <td><DetallePopOver detalle={cliente.info} nombre={cliente.nombre} apellido={cliente.apellido} /></td>
                          <td>{cliente.cumpleaños}</td>
                          <td>{cliente.largo_pelo}</td>
                          <td>
                            <EditClienteModal
                              cliente={cliente}
                              updateCliente={updateCliente}
                              setBusqueda={setBusqueda}
                            />
                            <DeleteClienteButton
                              id={cliente.id}
                              deleteCliente={deleteCliente}
                              setClientes={setClientes}
                            />
                          </td>
                        </tr>
                      );
                    })}
              </tbody>
            </table>
          </div>

          <br />

          <Paginator items={clientes} setDisplayItems={setDisplayClientes} />


          {/* <Birthday clientes={clientes} /> */}

        </>
      )}
    </div>
  );
};

export default TablaClientes;
